import React, { useEffect } from 'react';
import { Box } from '@chakra-ui/react';
import { FAQ } from '../components/Landing/FAQ';
import { TestDetails } from '../components/UserOrders/TestDetails';

export const TestOrderDetails = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Box
      sx={{
        display: 'flex',
        maxWidth: '100%',
        height: '85vh',
        flexDir: 'column',
        px: ['3', '5', '10', '20'],
        py: 5,
        gap: 5,
        overflowY: 'scroll',
        zIndex: '1000',
        pb: '100px',
      }}
    >
      <Box>
        <TestDetails />
        <FAQ />
      </Box>
    </Box>
  );
};
